import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import ThreeDotsDropdown from 'components/ThreeDotsDropdown';
import useManageQuestion from '../../hooks/useManageFaq';
import {
  PublishedCellComponent,
  SubjectCellComponent,
} from '../FaqListTable/FaqListTable.component';
import { ALIGNMENT } from 'models/Global';
import useDeleteQuestion from '../../hooks/useDeleteFaq';

import './FaqMobileCard.styles.scss';

type FaqMobileCardProps = {
  question: Question;
  hasManagePermission?: boolean;
};

const FaqMobileCard: FC<FaqMobileCardProps> = ({
  question,
  hasManagePermission,
}) => {
  const classes = classNames('faq-mobile-card');
  const { t } = useTranslation();

  const { ManageDrawer, openDrawer } = useManageQuestion(question);
  const { canDeleteFaq, onDelete } = useDeleteQuestion(question);

  const manageOptions = useMemo(
    () => [
      {
        label: t('manage'),
        onClick: openDrawer,
      },
      ...(canDeleteFaq
        ? [
            {
              label: t('delete'),
              onClick: onDelete,
            },
          ]
        : []),
    ],
    [canDeleteFaq, t, openDrawer, onDelete],
  );

  return (
    <div className={classes}>
      {hasManagePermission && (
        <>
          <ThreeDotsDropdown
            className="faq-mobile-card__manage"
            withBorder={false}
            alignment={ALIGNMENT.VERTICAL}
            options={manageOptions}
          />
          {ManageDrawer}
        </>
      )}

      <SubjectCellComponent question={question} />
      <PublishedCellComponent question={question} />
    </div>
  );
};

export default FaqMobileCard;
